import { initExternalVideo } from './externalVideo';

document.addEventListener('DOMContentLoaded', () => {
    initExternalVideo();
});
